module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-53-09-849.326bec21.mp4";